// crm namespace — Email Automation (admin/crm/pages/CrmEmailAutomation.jsx,
// admin/crm/email/*): sequence grid, birthday wishes, sending domain.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "email.pageTitle": "Automatisation des e-mails",
    "email.newSequence": "+ Nouvelle séquence",
    "email.sendBroadcast": "Envoyer un e-mail groupé",
    "email.stepCount.one": "{n} étape",
    "email.stepCount.other": "{n} étapes",
    "email.stats": "Envoyés {sent} · Ouverts {opened}",
    "email.statsEmpty": "Envoyés · Ouverts",
    "email.edit": "Modifier",
    "email.duplicate": "Dupliquer",
    "email.duplicated": "Séquence dupliquée",
    "email.birthdayTitle": "Vœux d'anniversaire",
    "email.birthdayBody": "Quand activé, envoie un e-mail d'anniversaire pré-rédigé le jour et le mois de naissance du client. Rien d'autre à configurer.",
    "email.birthdayEdit": "Modifier le message",
    "email.birthdayOn": "Vœux d'anniversaire activés",
    "email.birthdayOff": "Vœux d'anniversaire désactivés",
    "email.birthdayDialogTitle": "Message d'anniversaire",
    "email.birthdaySaved": "Message enregistré",
    "email.domainTitle": "Domaine d'envoi",
    "email.domainDefault": "Par défaut : {address} (sous-domaine)",
    "email.domainOwn": "Domaine personnalisé : {domain}",
    "email.domainInputLabel": "Domaine personnalisé",
    "email.domainConnect": "Connecter",
    "email.domainConnectPlaceholder": "votredomaine.com",
    "email.domainConnected": "Domaine en cours de vérification",
    "email.domainVerify": "Vérifier",
    "email.domainVerified": "Domaine vérifié",
    "email.domainDisconnect": "Déconnecter",
    "email.domainDisconnected": "Domaine déconnecté",
    "email.domainFallback": "Tant qu'il n'est pas vérifié, les envois utilisent le sous-domaine.",
  },
  en: {
    "email.pageTitle": "Email Automation",
    "email.newSequence": "+ New sequence",
    "email.sendBroadcast": "Send broadcast",
    "email.stepCount.one": "{n} step",
    "email.stepCount.other": "{n} steps",
    "email.stats": "Sent {sent} · Opened {opened}",
    "email.statsEmpty": "Sent · Opened",
    "email.edit": "Edit",
    "email.duplicate": "Duplicate",
    "email.duplicated": "Sequence duplicated",
    "email.birthdayTitle": "Birthday wishes",
    "email.birthdayBody": "When on, sends a pre-written birthday email on the client's day and month of birth. Nothing else to configure.",
    "email.birthdayEdit": "Edit message",
    "email.birthdayOn": "Birthday wishes turned on",
    "email.birthdayOff": "Birthday wishes turned off",
    "email.birthdayDialogTitle": "Birthday message",
    "email.birthdaySaved": "Message saved",
    "email.domainTitle": "Sending domain",
    "email.domainDefault": "Default: {address} (subdomain)",
    "email.domainOwn": "Own domain: {domain}",
    "email.domainInputLabel": "Own domain",
    "email.domainConnect": "Connect",
    "email.domainConnectPlaceholder": "yourdomain.com",
    "email.domainConnected": "Domain is being verified",
    "email.domainVerify": "Verify",
    "email.domainVerified": "Domain verified",
    "email.domainDisconnect": "Disconnect",
    "email.domainDisconnected": "Domain disconnected",
    "email.domainFallback": "Until verified, sends use the subdomain.",
  },
  es: {
    "email.pageTitle": "Automatización de correos",
    "email.newSequence": "+ Nueva secuencia",
    "email.sendBroadcast": "Enviar correo masivo",
    "email.stepCount.one": "{n} paso",
    "email.stepCount.other": "{n} pasos",
    "email.stats": "Enviados {sent} · Abiertos {opened}",
    "email.statsEmpty": "Enviados · Abiertos",
    "email.edit": "Editar",
    "email.duplicate": "Duplicar",
    "email.duplicated": "Secuencia duplicada",
    "email.birthdayTitle": "Felicitaciones de cumpleaños",
    "email.birthdayBody": "Cuando está activado, envía un correo de cumpleaños predefinido el día y mes de nacimiento del cliente. Nada más que configurar.",
    "email.birthdayEdit": "Editar mensaje",
    "email.birthdayOn": "Felicitaciones de cumpleaños activadas",
    "email.birthdayOff": "Felicitaciones de cumpleaños desactivadas",
    "email.birthdayDialogTitle": "Mensaje de cumpleaños",
    "email.birthdaySaved": "Mensaje guardado",
    "email.domainTitle": "Dominio de envío",
    "email.domainDefault": "Predeterminado: {address} (subdominio)",
    "email.domainOwn": "Dominio propio: {domain}",
    "email.domainInputLabel": "Dominio propio",
    "email.domainConnect": "Conectar",
    "email.domainConnectPlaceholder": "tudominio.com",
    "email.domainConnected": "El dominio se está verificando",
    "email.domainVerify": "Verificar",
    "email.domainVerified": "Dominio verificado",
    "email.domainDisconnect": "Desconectar",
    "email.domainDisconnected": "Dominio desconectado",
    "email.domainFallback": "Hasta que se verifique, los envíos usan el subdominio.",
  },
};
